/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import classNames from 'classnames';
import {
  bool,
  string,
  node,
  object,
  func,
  oneOf,
  oneOfType,
} from 'prop-types';
import Icon from './Icon';
import Small from './Small';

import './Checkbox.scss';

class Checkbox extends React.Component {
  static getDerivedStateFromProps(
    {
      selected: nextSelected,
      isClean: nextIsClean,
    },
    {
      selected: prevSelected,
      isClean: prevIsClean,
    }
  ) {
    const state = {};
    if (typeof nextSelected === 'boolean' && nextSelected !== prevSelected) {
      state.selected = nextSelected;
    }
    if (nextIsClean !== prevIsClean) {
      state.isClean = false;
    }
    return state;
  }

  constructor(props) {
    super(props);
    this.state = {
      selected: false,
      isClean: props.isClean,
    };
    this.toggleSelected = this.toggleSelected.bind(this);
  }

  toggleSelected(e) {
    if (e.target.tagName.toLowerCase() === 'a') return;
    const { onChange } = this.props;
    const { selected } = this.state;
    this.setState({
      selected: !selected,
      isClean: false,
    });
    if (onChange) onChange(!selected);
  }

  render() {
    const { selected, isClean } = this.state;
    const {
      indetermine,
      label,
      labelHtml,
      disabled,
      children,
      error,
      alignItems,
      validationText,
      isShowValidationIcon,
      dataSelectorId,
    } = this.props;
    const classes = {
      checkbox: true,
      selected,
      disabled,
      error: !isClean && error ? error : false,
    };

    const iconName = indetermine ? 'indetermine' : 'check';

    return (
      <div
        className={classNames(classes)}
        onClick={!disabled ? this.toggleSelected : undefined}
        style={{ alignItems }}
        data-selector={dataSelectorId}
      >
        <div className="checkbox-icon">
          {selected && (
            <Icon
              name={iconName}
            />
          )}
        </div>
        <div>
          {labelHtml && (
            // eslint-disable-next-line react/no-danger
            <div className="checkbox-label" dangerouslySetInnerHTML={{ __html: labelHtml }} />
          )}
          {label && (
            <div className="checkbox-label">
              {label}
            </div>
          )}
          {children && (
            <div className="checkbox-label">
              {children}
            </div>
          )}
          {validationText && !isClean && (
            <div className="checkbox-validation-wrapper">
              {isShowValidationIcon && (
                <span className="checkbox-validation-icon">
                  <Icon name="info" />
                </span>
              )}
              <Small>{validationText}</Small>
            </div>
          )}
        </div>
      </div>
    );
  }
}

Checkbox.defaultProps = {
  indetermine: false,
  label: null,
  labelHtml: null,
  children: null,
  disabled: false,
  error: false,
  alignItems: 'center', // TODO: go through and see if checkbox is every used align-center
  selected: null,
  onChange: undefined,
  validationText: null,
  isShowValidationIcon: true,
  isClean: true,
  dataSelectorId: '',
};

Checkbox.propTypes = {
  /** Checkbox style "Indetermined" */
  indetermine: bool,

  /** Accessory label text */
  label: oneOfType([string, object]),

  /** Accessory label html */
  labelHtml: string,

  /** Custom accessory component */
  children: node,

  /** State "disabled" */
  disabled: bool,

  /** State "error" */
  error: bool,

  /** State "isClean" */
  isClean: bool,

  /** Alignment between checkbox & accessory component (label or children) */
  alignItems: oneOf(['flex-start', 'center', 'flex-end']),

  /** Checkbox selected */
  selected: bool,

  /** On change callback  */
  onChange: func,

  /** Validation text */
  validationText: string,

  /** is show validation icon */
  isShowValidationIcon: bool,

  /** id hook for automation tests */
  dataSelectorId: string,
};

export default Checkbox;
